import { formatPhone } from '../redux/FeedbackRedux'

jQuery(document).ready(function () {
  if (jQuery('.regional-sidebar').length > 0) {
    jQuery('.business-li .nav-item').each(function () {
      doPadding(jQuery(this));
    });
    jQuery('.region-li .nav-item').each(function () {
      doPadding(jQuery(this));
    });
  }

  jQuery('.region-item').each(function () {
    jQuery(this).find('.region-li').hide();
    jQuery(this).find('.business-li').hide();
  });

  jQuery('.region-item').each(function () {
    jQuery(this).find('.region-li').removeClass("hidden");
    jQuery(this).find('.business-li').removeClass("hidden");
  });

  jQuery('.region-item .row a').click(function (e) {
    if (jQuery(e.target).is('i')) {
      e.preventDefault();
    }
  });

  jQuery('.region-item .row i').click(function (e) {
    if (jQuery(jQuery(this).closest('.row').parent().children()[1]).is(':hidden')) {
      doChevron(jQuery(this).parent());
      jQuery(this).closest('.row').parent().children('.region-li, .business-li').show();
    }
    else if (jQuery(jQuery(this).closest('.row').parent().children()[1]).is(':visible')) {
      doChevron(jQuery(this).parent());
      jQuery(this).closest('.row').parent().children('.region-li, .business-li').hide();
    }
  });

  function doChevron(el) {
    if (jQuery(el).find('i').hasClass('fa-chevron-right')) {
      jQuery(el).find('i').addClass('fa-chevron-down');
      jQuery(el).find('i').removeClass('fa-chevron-right');
    }
    else if (jQuery(el).find('i').hasClass('fa-chevron-down')) {
      jQuery(el).find('i').addClass('fa-chevron-right');
      jQuery(el).find('i').removeClass('fa-chevron-down');
    }
  }

  //selected regions
  var elem = jQuery('body').find('.region-item.is_selected');
  elem.children().find('i').first().removeClass('fa-chevron-right');
  elem.children().find('i').first().addClass('fa-chevron-down');
  elem.children('.region-li, .business-li').show();
  recurseParent(elem);

  function recurseParent(elem) {
    var elem = elem;
    elem.find('h5').first().find('i').removeClass('fa-chevron-right').addClass('fa-chevron-down');
    if (elem.parents('.region-item').first().length > 0) {
      elem.parents('.region-item').first().children('.region-li, .business-li').show();
      recurseParent(elem.parents('.region-item').first());
    }
  }

  function doPadding(element) {
    var mul = element.parents('.region-item').length;
    element.find('.nav-link').find('h5').css('padding-left', 10 * mul + 'px');
  }

  window.deps = [];
  window.deps_app = [];
  window.deps_sms = [];
  window.deps_email = [];

    // @todo identify where this is needed and apply in place correction. Check getUrlQueryStringParameterByName() and removeQueryParameters() from autopilot-results.blade.php
    // left this in here just for /timeframe path to not affect query strings
  if (window.location.href.indexOf("/timeframe") > -1) {
      console.log("remove all from url because of timeframe", window.location.pathname);

    var s = window.location.pathname;
    s.split("/timeframe")[0];
    window.history.pushState({}, document.title, s.split("/timeframe")[0]);
  }

  jQuery(document).on('click', '.img-attachment.pdf-attachment-small, .img-attachment.pdf-attachment', function () {
    const src = jQuery(this)[0].dataset.fullImageUrl ?? jQuery(this).attr('src');
    var win = window.open(src, '_blank');
    if (win) {
      //Browser has allowed it to be opened
      win.focus();
    } else {
      //Browser has blocked it
      alert('Please allow popups for this website');
    }
  });

  jQuery(document).on('click', '.img-attachment:not(.pdf-attachment-small):not(.pdf-attachment)', function () {
    const src = jQuery(this)[0].dataset.fullImageUrl ?? jQuery(this).attr('src');
    const img = `
    <div class="d-flex w-100 h-100 attachment-modal">
      <div class="attachment-modal-wrapper">
        <img src="`+ src + `" class="attachment"  alt="" />
        <span class="close close-attachment cursor-pointer text-white">x</span>
      </div>
    </div>
    `
    jQuery('body').append(img);
  });

  jQuery('body').on('click', '.attachment-modal .close-attachment', function () {
    jQuery('body').find('.attachment-modal').remove();
  });

  jQuery('body').on('click', '.attachment-modal', function (e) {
    if (jQuery(e.target).prop("tagName") != "IMG") {
      jQuery('body').find('.attachment-modal').remove();
    }
  });

  jQuery('.makecsrf').each(function () {
    var c = jQuery('meta[name="csrf-token"]').attr('content');
    jQuery(this).val(c);
  });

  if (jQuery('.checkboxes').length > 0) {
    initialBoxes();
    checkBoxes();
  }

  if (jQuery('.hasnodeps').length > 0) {
    checkBoxes();
  }

  setTimeout(function () {
    jQuery('.alert-success').hide();
  }, window.delay_alert_show_time ?? 5000);

  jQuery('.checkboxes input, alt-checkboxes input').click(function () {
    checkBoxes();
  });

  jQuery('.checkbox-clear-all').click(function (e) {
    //do the things
    e.preventDefault();
    jQuery('input[type="checkbox"]').prop("checked", false);
    checkBoxes();
  });

  jQuery('.checkbox-select-all').click(function (e) {
    //do the things
    e.preventDefault();

    // if all checkboxes of departments are checked
    // show
    if ($('.department-checkbox').length > 0) {
      $('.department').show();
    }

    jQuery('.is_app, .is_email, .department-checkbox').prop("checked", true);
    checkBoxes();
  });

  jQuery('#sms_not_started_chats_value').keyup(function () {
    jQuery('.sms_not_started_chats_minutes_display').text(jQuery(this).val());
  });

  jQuery('#sms_not_started_chats_value').change(function () {
    jQuery('.sms_not_started_chats_minutes_display').text(jQuery(this).val());
  });


  jQuery('body').find('input .phone_number_input').each(function () {
    console.log("format phone");
    jQuery(this).val(jQuery(this).val().replace("+1", ""));
    var value = jQuery(this).val();
    var phone = formatPhone(value);
    jQuery(this).val(phone);
  });

  jQuery('body').on('keyup', '#call_number', function () {
    console.log("format phone");
    jQuery(this).val(jQuery(this).val().replace("+1", ""));
    var value = jQuery(this).val();
    var phone = formatPhone(value);
    jQuery(this).val(phone);
    var digitsOnly = phone.replace(/\D/g, '');
    if (digitsOnly.length > 0) {
      jQuery('#call_number_raw').val('+1' + digitsOnly);
    } else {
      jQuery('#call_number_raw').val('');
    }
  });


  // jQuery('body').on('keydown, input','.phone_number_input', function(e) {
  //   console.log("format phone");
  //   if (e.originalEvent.keyCode == 8) {
  //     return;
  //   }
  //   var value = jQuery(this).val();
  //   var phone = formatPhone(value);
  //   jQuery(this).val(phone);
  // });

  jQuery('body').on('keypress, change, input', '.phone_number_input', function (e) {
    let value = jQuery(this).val();
    if (value.length > 5) {
      value = formatPhone(value);
    }
    jQuery(this).val(value);
  });

  jQuery('body').on('paste', '.phone_number_input', function (e) {
    setTimeout(function () {
      var value = jQuery(e.target).val();
      var phone = formatPhone(value);
      jQuery(e.target).val(phone);
    }, 100);
  });


});

jQuery('body').on('click', '.view-history', function (e) {
  e.preventDefault();
  if (jQuery(this).attr('data-toggle') != 'open') {
    jQuery(this).attr('data-toggle', 'open');
    jQuery('body').find('.status-history').show();
  } else {
    jQuery(this).attr('data-toggle', 'closed');
    jQuery('body').find('.status-history').hide();
  }

});

jQuery(document).ready(function () {
  if (jQuery('.auto-search-bar').length > 0) {

    jQuery('.auto-search-bar').on("keyup", function () {
      var value = jQuery(this).val().toLowerCase();
      var selector = jQuery(this).attr('data-selector');
      jQuery(selector).filter(function () {
        jQuery(this).toggle($(this).find('td:not(.ignore)').text().toLowerCase().indexOf(value) > -1);
      });
    });

  }
  if (jQuery('.employee-search-bar').length > 0) {

    jQuery('.employee-search-bar').on("keyup", function () {
      var value = jQuery(this).val().toLowerCase();
      var selector = jQuery(this).attr('data-selector');

      jQuery(selector).filter(function () {
        jQuery(this).toggle($(this).find('*').text().toLowerCase().indexOf(value) > -1);
      });

    });

  }
});

function checkBoxes() {
  // RTF-5004: push_for_all_chat is deliberately NOT gated on push_for_all_feedback any more.
  // The two push preferences are independent per location, so "chat only at this location" has to
  // stay selectable. Re-adding the gate here would silently undo the same un-gating in
  // notification-settings-default.blade.php the moment this runs. push_for_local_feedback IS still
  // a child of the feedback preference, so its gate stays.
  if (jQuery('#push_for_all_feedback').prop('checked') == true) {
    jQuery('#push_for_local_feedback').parent().removeClass('hide');
  } else {
    jQuery('#push_for_local_feedback').parent().addClass('hide');
    // jQuery('#push_for_local_feedback').prop('checked',false);
  }
  if (jQuery('#sms_not_started_chats').prop('checked') == true) {
    jQuery('.hide_unless_sms_not_started_chats').removeClass('hide');
  } else {
    jQuery('.hide_unless_sms_not_started_chats').addClass('hide');
  }

  if (jQuery('#sms_for_all_feedback').prop('checked') == true) {
    jQuery('.sms_for_local_feedbacks').removeClass('hide');
    jQuery('.sms_for_all_chat').removeClass('hide');
  } else {
    jQuery('.sms_for_local_feedbacks').addClass('hide');
    jQuery('.sms_for_all_chat').addClass('hide');
  }

  if (jQuery('.department').length > 0) {
    jQuery('.department').each(function () {
      if (jQuery(this).find('input.department-checkbox:checked').length > 0) {
        jQuery(this).find('.notify-box').show();
        if (jQuery(this).hasClass('do-default')) {
          jQuery(this).closest('.department').find('.notify-box').find('.is_app').prop('checked', true);
          jQuery(this).closest('.department').find('.notify-box').find('.is_email').prop('checked', true);
          jQuery(this).removeClass('do-default');
        }
      } else {
        jQuery(this).find('.is_app').prop('checked', false);
        jQuery(this).find('.is_email').prop('checked', false);
        jQuery(this).find('.is_sms').prop('checked', false);
        jQuery(this).find('.notify-box').hide();
        jQuery(this).addClass('do-default');
      }
    });
    doHasDeps();
    doDepNamesApp();
    doDepNamesSMS();
    doDepNamesEmail();
    doDepNames();
    doCheckText();
    doIsApp();
    doIsSMS();
    doIsEmail();
  }


}

function doCheckText() {
    let all_chats = window.profileNotificationSettingsBlurbsForDepartments?.push_for_all_chat.replace('PLACEHOLDER', window.deps_app.join(', '));
    let local_chats = window.profileNotificationSettingsBlurbsForDepartments?.push_for_local_feedback.replace('PLACEHOLDER', window.deps_app.join(', '));
    let sms_all_chats = window.profileNotificationSettingsBlurbsForDepartments?.sms_for_all_chat.replace('PLACEHOLDER', window.deps_sms.join(", "));
    let email_all_chats = window.profileNotificationSettingsBlurbsForDepartments?.email_for_all_chat.replace('PLACEHOLDER', window.deps_email.join(", "));
    let local_text = window.profileNotificationSettingsBlurbsForDepartments?.sms_for_local_feedbacks.replace('PLACEHOLDER', window.deps_sms.join(", "));
    let feedback_reopen_notify = window.profileNotificationSettingsBlurbsForDepartments?.feedback_reopen_notify.replace('PLACEHOLDER', window.deps_app.join(", "));

    if (window.is_super_user) {
        all_chats = window.profileNotificationSettingsBlurbsForSuperAdmin?.push_for_all_chat;
        local_chats = window.profileNotificationSettingsBlurbsForSuperAdmin?.push_for_local_feedback;
        sms_all_chats = window.profileNotificationSettingsBlurbsForSuperAdmin?.sms_for_all_chat;
        email_all_chats = window.profileNotificationSettingsBlurbsForSuperAdmin?.email_for_all_chat;
        local_text = window.profileNotificationSettingsBlurbsForSuperAdmin?.sms_for_local_feedbacks;
        feedback_reopen_notify = window.profileNotificationSettingsBlurbsForSuperAdmin?.feedback_reopen_notify;
    }

    jQuery('.fill-all-chat').text(all_chats);
    jQuery('.fill-push-local').text(local_chats);
    jQuery('.fill-sms-all-chat').text(sms_all_chats);
    jQuery('.fill-email-all-chat').text(email_all_chats);
    jQuery('.fill-text-local').text(local_text);
    jQuery('.fill-feedback-reopen-notify').text(feedback_reopen_notify);
}

function doDepNames() {
  if (jQuery('.alt-checkboxes').length > 0) {
    jQuery('input.department-checkbox').each(function () {
      if (jQuery(this).prop("checked") == true) {
        var text = jQuery(this).closest('label').find('span').text();
        var index = window.deps.indexOf(text);
        //console.log(text);
        if (index === -1) {
          window.deps.push(text);
        }
      } else {
        var text = jQuery(this).closest('label').find('span').text();
        var index = window.deps.indexOf(text);
        if (index !== -1) {
          window.deps.splice(index);
        }
      }
    });
  }
  //console.log(window.deps);
}

function doDepNamesSMS() {
  if (jQuery('.alt-checkboxes').length > 0) {
    jQuery('.is_sms').each(function () {
      if (jQuery(this).prop("checked") == true) {
        var text = jQuery(this).closest('.department').find('span.depname').text();
        var index = window.deps_sms.indexOf(text);
        //console.log(text);
        if (index === -1) {
          window.deps_sms.push(text);
        }
      } else {
        var text = jQuery(this).closest('.department').find('span.depname').text();
        var index = window.deps_sms.indexOf(text);
        if (index !== -1) {
          window.deps_sms.splice(index);
        }
      }
    });
  }
  //console.log(window.deps_app);
}

function doDepNamesEmail() {
  if (jQuery('.alt-checkboxes').length > 0) {
    jQuery('.is_email').each(function () {
      if (jQuery(this).prop("checked") == true) {
        var text = jQuery(this).closest('.department').find('span.depname').text();
        var index = window.deps_email.indexOf(text);
        //console.log(text);
        if (index === -1) {
          window.deps_email.push(text);
        }
      } else {
        var text = jQuery(this).closest('.department').find('span.depname').text();
        var index = window.deps_email.indexOf(text);
        if (index !== -1) {
          window.deps_email.splice(index);
        }
      }
    });
  }
  //console.log(window.deps_app);
}

function doDepNamesApp() {
  if (jQuery('.alt-checkboxes').length > 0) {
    jQuery('.is_app').each(function () {
      if (jQuery(this).prop("checked") == true) {
        var text = jQuery(this).closest('.department').find('span.depname').text();
        var index = window.deps_app.indexOf(text);
        //console.log(text);
        if (index === -1) {
          window.deps_app.push(text);
        }
      } else {
        var text = jQuery(this).closest('.department').find('span.depname').text();
        var index = window.deps_app.indexOf(text);
        if (index !== -1) {
          window.deps_app.splice(index);
        }
      }
    });
  }
  //console.log(window.deps_app);
}

function doIsSMS() {
  if (jQuery('.is_sms:checked').length > 0) {
    jQuery('.sms_for_local_feedbacks').removeClass('hide');
    jQuery('.sms_for_all_chat').removeClass('hide');
  } else {
    jQuery('.sms_for_local_feedbacks').addClass('hide');
    jQuery('.sms_for_all_chat').addClass('hide');
  }
}
function doIsEmail() {
  if (jQuery('.is_email:checked').length > 0) {
    jQuery('.email_for_all_chat').removeClass('hide');
  } else {
    jQuery('.email_for_all_chat').addClass('hide');
  }
}

function doIsApp() {
  // RTF-5004: push_for_all_chat is deliberately NOT gated here any more. Chat push is a per-location
  // preference of its own now, independent of the department "Notify via app" pivot — keeping the gate
  // meant that on a departmented location, unticking every department app box hid the chat control and
  // made it unreachable, which is the same trap this ticket removed from checkBoxes(). Only
  // push_for_local_feedback stays gated: it is still a global child of feedback push.
  if (jQuery('.is_app:checked').length > 0) {
    jQuery('.push_for_local_feedback').removeClass('hide');
  } else {
    jQuery('.push_for_local_feedback').addClass('hide');
  }
}

function doHasDeps() {
  if (jQuery('input.department-checkbox:checked').length > 0) {
    jQuery('.sms_not_started_chats').addClass('d-flex');
    jQuery('.sms_not_started_chats').show();
  } else {
    jQuery('.sms_not_started_chats').removeClass('d-flex');
    jQuery('.sms_not_started_chats').hide();
  }
}

function initialBoxes() {
  jQuery('.checkboxes input').each(function () {
    if (jQuery(this).prop('checked') == true) {
      jQuery(this).prop('checked', true);
    } else {
      jQuery(this).prop('checked', false);
    }
  });
}
window.collapsedGroups = {};
jQuery(document).ready(function () {
  if (jQuery('.page-loading').length > 0) {
    jQuery('.page-loading').hide();
  }

  function secondsToDhms(seconds) {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor(seconds % (3600 * 24) / 3600);
    var m = Math.floor(seconds % 3600 / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay = d > 0 ? d + (d == 1 ? "d, " : "d, ") : "";
    var hDisplay = h > 0 ? h + (h == 1 ? "h, " : "h, ") : "";
    var mDisplay = m > 0 ? m + (m == 1 ? "m, " : "m, ") : "";
    var sDisplay = s > 0 ? s + (s == 1 ? "s" : "s") : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  }

  window.first_render = true;

  if ($('#sortTable').length > 0) {
    var table = $('#sortTable').DataTable(
      {
        "paging": false,
        "info": false,
        "order": [[0, "asc"]],
        "searching": false,
        "destroy": true,
      });

    if (jQuery('body').width() > 1000) {
      // new $.fn.dataTable.FixedHeader( table, {
      //   // options
      // } );
    }

    var super_table = $('#sortTable.super_user').DataTable(
      {
        "paging": false,
        "info": false,
        "order": [[0, "asc"]],
        "orderFixed": [[0, "asc"]],
        "searching": true,
        "destroy": true,
        "rowGroup": {
          dataSrc: 0,
          startRender: function (rows, group) {
            if (window.first_render) {
              var collapsed = true;
            } else {
              var collapsed = !!window.collapsedGroups[group];
            }

            rows.nodes().each(function (r) {
              r.style.display = collapsed ? 'none' : '';
            });

            // Add category name to the <tr>. NOTE: Hardcoded colspan
            var total = rows
              .data()
              .pluck(2)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var open = rows
              .data()
              .pluck(3)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var pending = rows
              .data()
              .pluck(4)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var resolved = rows
              .data()
              .pluck(5)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var chats_requested = rows
              .data()
              .pluck(6)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var chats_started = rows
              .data()
              .pluck(7)
              .reduce(function (a, b) {
                var f = jQuery(jQuery.parseHTML(b)[0]).text();
                f = f.replace(" ", "").split("(")[0];
                f = parseInt(f);
                return a + f;
              }, 0);
            var links_sent = rows
              .data()
              .pluck(8)
              .reduce(function (a, b) {
                var f = parseInt(jQuery(jQuery.parseHTML(b)[0]).text());
                return a + f;
              }, 0);
            var smiley_divisor = 0;
            var smiley_score = rows
              .data()
              .pluck(9)
              .reduce(function (a, b) {
                if (b && b != "No Data") {
                  b = b.split("</i>")[1];
                  b = b.replace(" ", "");
                  b = b.replace("%", "");
                  b = parseInt(b);
                  smiley_divisor += 1;
                } else {
                  b = 0;
                }
                return a + b;
              }, 0);
            var score_divisor = 0;
            var score_score = rows
              .data()
              .pluck(10)
              .reduce(function (a, b) {
                if (b && b != "No Data") {
                  b = b.replace(" ", "");
                  b = b.replace("%", "");
                  b = parseInt(b);
                  score_divisor += 1;
                } else {
                  b = 0;
                }
                return a + b;
              }, 0);
            var resp_divisor = 0;
            var resp_time = rows
              .data()
              .pluck(11)
              .reduce(function (a, b) {
                if (!b.includes("No Data")) {
                  b = parseInt(jQuery(jQuery.parseHTML(b)[0]).attr("data-time"));
                  resp_divisor += 1;
                } else {
                  b = 0;
                }
                return a + b;
              }, 0);
            return $('<tr/>')
              .append('<td>' + group + ': ' + rows.count() + (rows.count() > 1 ? ' Locations' : ' Location') + '</td>')
              .append('<td/>')
              .append('<td>' + total + '</td>')
              .append('<td>' + open + '</td>')
              .append('<td>' + pending + '</td>')
              .append('<td>' + resolved + '</td>')
              .append('<td>' + chats_requested + '</td>')
              .append('<td>' + chats_started + '</td>')
              .append('<td>' + links_sent + '</td>')
              .append('<td>' + (smiley_score && smiley_divisor ? (smiley_score / smiley_divisor).toFixed(1) + "%" : 'No Data') + '</td>')
              .append('<td>' + (score_score && score_divisor ? (score_score / score_divisor).toFixed(1) + "%" : 'No Data') + '</td>')
              .append('<td>' + (resp_time && resp_divisor ? secondsToDhms((resp_time / resp_divisor)) : 'No Data') + '</td>')
              .attr('data-name', group)
              .toggleClass('collapsed', collapsed);
          }, "initComplete": function () {
            $('body').find('tr.dtrg-start').each(function () {
              var name = $(this).data('name');
              window.collapsedGroups[name] = !window.collapsedGroups[name];
            });
            console.log("running the command, here is the collapsedGroups: ");
            console.log(window.collapsedGroups);
          },
        }
      });

    window.first_render = false;
  }

  if ($('#sortTableQR').length > 0) {
    var table = $('#sortTableQR').DataTable(
      {
        "paging": false,
        "info": false,
        "order": [[0, "desc"]],
        "searching": true,
        "destroy": true,
      });
  }


  if ($('.sortTables').length > 0) {
    $('.sortTables').each(function () {
      $(this).DataTable(
        {
          "paging": false,
          "info": false,
          "order": [[0, "asc"]],
          "searching": true,
          "destroy": true,
        });
    });
  }

  $('body').on('click', '.dtrg-start', function () {
    var table = $("#sortTable").DataTable();
    var name = $(this).data('name');
    window.collapsedGroups[name] = !window.collapsedGroups[name];
    table.draw(false);
  });
});

jQuery('.switchbutton').click(function () {
  if (jQuery('body').width() <= 1000) {
    if (jQuery('body').find('.feedback-detail').hasClass('is-hidden-mobile')) {
      jQuery('body').find('.feedback-list').addClass('is-hidden-mobile');
      jQuery('body').find('.dashboard-stats').addClass('is-hidden-mobile');
      jQuery('body').find('.feedback-detail').removeClass('is-hidden-mobile');
    } else if (jQuery('body').find('.feedback-list').hasClass('is-hidden-mobile')) {
      jQuery('body').find('.feedback-detail').addClass('is-hidden-mobile');
      jQuery('body').find('.dashboard-stats').removeClass('is-hidden-mobile');
      jQuery('body').find('.feedback-list').removeClass('is-hidden-mobile');
    }
  }
});

//TEXTAREA KIIIING
$('textarea').each(function () {
  this.setAttribute('style', 'height:' + (this.scrollHeight) + 'px;overflow-y:hidden;');
}).on('input', function () {
  this.style.height = 'auto';
  this.style.height = (this.scrollHeight) + 'px';
});


jQuery('.editname').click(function () {
  window.location = "/business-group/" + jQuery(this).attr('data-bgroup') + "/business/" + jQuery(this).attr('data-bgroup') + "/rename";
});

jQuery('.nav-item').hover(
  function () {
    if ($(this).find(".editname").length > 0) {
      $(this).addClass('hovering');
    }

  }, function () {

    if ($(this).find(".editname").length > 0) {
      $(this).removeClass('hovering');
    }

  }
);



$(document).ready(function () {
  var x = 0;
  setInterval(function () {
    var dots = ".";
    x++;
    for (var y = 0; y < x % 3; y++) {
      dots += ".";
    }
    $("#loading-dots").text(dots);
  }, 500);
  jQuery('body').on('click', '.showpassword', function () {
    console.log("click");
    console.log(jQuery(this).parent().find('input').attr('type'));
    if (jQuery(this).parent().find('input').attr('type') == 'password') {
      jQuery(this).parent().find('input').attr('type', 'text');
      jQuery(this).find('.fa-eye-slash').addClass('fa-eye');
      jQuery(this).find('.fa-eye-slash').removeClass('fa-eye-slash');
    } else {
      jQuery(this).parent().find('input').attr('type', 'password');
      jQuery(this).find('.fa-eye').addClass('fa-eye-slash');
      jQuery(this).find('.fa-eye').removeClass('fa-eye');
    }
  });
});


